import { render, staticRenderFns } from "./Question3.vue?vue&type=template&id=ac48d3c0&scoped=true&"
import script from "./Question3.vue?vue&type=script&lang=js&"
export * from "./Question3.vue?vue&type=script&lang=js&"
import style0 from "./Question3.vue?vue&type=style&index=0&id=ac48d3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac48d3c0",
  null
  
)

component.options.__file = "Question3.vue"
export default component.exports